module.exports = {"542222100":"扎唐镇","542222101":"桑耶镇","542222200":"阿扎乡","542222201":"扎其乡","542222202":"吉汝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542222.json
// module id = 2540
// module chunks = 0